import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const AiUnionIcon = ({ size }: IconSvgProps) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 9 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.12528 0.993668C6.08041 0.362051 5.28091 0.11762 4.89052 0.616167L3.35545 2.57653L0.871838 2.75294C0.24022 2.7978 -0.00421059 3.5973 0.494337 3.98769L2.4547 5.52276L2.63111 8.00638C2.67597 8.63799 3.47547 8.88243 3.86586 8.38388L5.40094 6.42352L7.88455 6.24711C8.51617 6.20224 8.7606 5.40274 8.26205 5.01235L6.30169 3.47728L6.12528 0.993668Z"
            fill="currentColor"
        />
    </svg>
);
